import { useState } from 'react'

export const useInsightsActions = () => {
  const [isShown, setIsShown] = useState(false)

  const handleShowToggle = () => setIsShown((s) => !s)

  return { isShown, handleShowToggle }
}
